module.exports = __webpack_public_path__ + "static/media/gestaoTrafegoProfissionalGoogleAds.f8797155.png";